import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      d: "M13.96 7.293a1 1 0 1 1 1.414 1.414L9.08 15h16.253l.101.005a1 1 0 0 1 0 1.99l-.101.005H9.08l6.293 6.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-8-8a1 1 0 0 1 0-1.414l8-8Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "back-arrow"}) } }